import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Container, Row, Col, Form, Button, Modal, ModalBody } from 'react-bootstrap';
import back from '../../assets/img/icons/back.svg'
import textlogo from '../../assets/img/textlogo.svg'
import axios from 'axios';
import ls from "local-storage";
import activated from '../../assets/img/activated.svg';
import close from '../../assets/img/icons/close.svg';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Verify extends Component {
    constructor(props) {
        super(props);
        this.handleNotreceivecode = this.handleNotreceivecode.bind(this);
        this.state = {
            codevalue: '',
            langKey: ls.get('LangValue'),
            errorMsg: '',
            errors: {},
            api_url: localStorage.getItem('api_url'),
            accountActivated: false,
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    handleChange = (e) => {
        const { value } = e.target;
        if (/^\d*$/.test(value) && value.length <= 4) {
            this.setState({ 
                codevalue: value 
            });
        }
    }

    handleSubmitaccountActivated = e => {
        e.preventDefault(); 
        let errors = {};
        if(this.state.codevalue === '' || this.state.codevalue === null) {
            errors["otpverify"] = "Enter 4 digits OTP";  
            this.setState({
                errors: errors,
                errorMsg:'errorMsg'
            });
            setTimeout(() => {
                this.setState({
                    errorMsg: 'errorMsghide'
                });
            }, 2000);
        } else {
            var emailVerify = new FormData();
            emailVerify.set('otp', this.state.codevalue);
            emailVerify.set('email', localStorage.getItem('signin_email'));
            emailVerify.set('language', this.state.langKey);   
            
            axios({
                method: 'post',
                url: this.state.api_url+'verifyaccountweb',
                data: emailVerify,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => { 
                if(res.data.status !== "true") { 
                    errors["otpverify"] = res.data.message;  
                    this.setState({
                        errors: errors,
                        errorMsg:'errorMsg'
                    });
                    setTimeout(() => {
                        this.setState({
                            errorMsg: 'errorMsghide'
                        });
                    }, 2000);  
                } else {
                    this.setState({
                        accountActivated: true
                    });
                }
            });
        }
    }

    handleNotreceivecode() {
        var accountActivated = new FormData();
        accountActivated.append('email', localStorage.getItem('signin_email'));
        accountActivated.append('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url + 'activateaccountweb',
            data: accountActivated,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            if (res.data.status === 'true') {
                this.setState({ otpsend: 'OTP send successfully' });
                setTimeout(() => {
                    this.setState({
                        otpsend: ''
                    });
                }, 5000);
            }
        });
    }

    handleRedirect = () => {
        this.props.history.push('/');
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div className="layout">
                    <Container>
                        <div className='welcome_header verify_header'>
                            <div className='welcomeheader_left'>
                                <Link to='/'>
                                    <img src={back} alt="img" />
                                </Link>
                                <Link to='/'>
                                    <img src={textlogo} alt="img" className='couponimage_logo' />
                                </Link>
                            </div>
                        </div>
                    </Container>
                    <div className='verify_divs'>
                        <Container>
                            <Row>
                                <Col md={12}>
                                    <div className='verify_section'>
                                        <div className='otp_verify'>
                                            <p><Trans i18nKey="OTP sent your registered email, please enter to activate.">OTP sent your registered email, please enter to activate.</Trans></p>
                                        </div>
                                        <div className='verify_form'>
                                            <div>
                                                <h4><Trans i18nKey="Verify your email">Verify your email</Trans></h4>
                                                <p><Trans i18nKey="Enter the OTP code just sent to the xyz@gmail.com.">Enter the OTP code just sent to the xyz@gmail.com.</Trans></p>

                                                <div className='verify_input'>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={t("Enter 4 digits code")}
                                                        value={this.state.codevalue}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div className={this.state.errorMsg}>
                                                        {this.state.errors.otpverify}
                                                    </div>
                                                    <>
                                                        <Form.Text className="receive_code" onClick={this.handleNotreceivecode}><Trans i18nKey="I didn't receive a code">I didn't receive a code</Trans></Form.Text>
                                                    </>
                                                    <div className="errorMsg">{this.state.otpsend}</div>
                                                </div>
                                                <div className='verify_btn'>
                                                    <Button className='button_primary' onClick={this.handleSubmitaccountActivated}>
                                                        <Trans i18nKey="CONTINUE">CONTINUE</Trans>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div >

                <Modal className="modal_div accountactivate_modal boostplan_modal" show={this.state.accountActivated} centered>
                    <Modal.Body className="accountactivatemodal">
                        <div className='accountactivate_img'>
                            <img src={activated} alt="img" />
                        </div>
                        <div className='boostplan_content accountactivatedivs'>
                            <h4><Trans i18nKey="Your account has been activated successfully, please login to continue.">Your account has been activated successfully, please login to continue.</Trans></h4>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="forgot_button_plr boostplan_activate boostplan_button">
                        <Button className='button_primary' onClick={this.handleRedirect}>
                            <Trans i18nKey="Login">Login</Trans>
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(Verify);
